import { defineStore } from 'pinia';

export const useGlobalStore = defineStore('global', {
    actions: {
        scrollToTop() {
            setTimeout(() => 
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
            500);     
        }
    }
});